import React from 'react';

/** Replaces the two hand-rolled document.createElement "Saving quote..." indicators. */
const BusyOverlay = ({ label }) => {
  if (!label) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        padding: '15px 20px', backgroundColor: 'rgba(0, 0, 0, 0.8)', color: 'white',
        borderRadius: '5px', zIndex: 9999,
      }}
    >
      {label}
    </div>
  );
};

export default BusyOverlay;
